export default {
    env: "prod",
    baseUrlWithoutAuth: "https://www.airtel.in/chatbot/",
    baseUrls: {
        ONLINE: {
            // DIGITAL_PROFILE_CONTEXT_URI: "https://www.airtel.in/as/app/wl-service/airtel-digital-profile/rest/"
            DIGITAL_PROFILE_CONTEXT_URI: "https://digi-api.airtel.in/app/wl-service/airtel-digital-profile/rest/"
        },
        HELPSUPPORT: {
            default: "https://www.airtel.in",
            NEW_DIGITAL_PROFILE_CONTEXT_URI: "https://digi-api.airtel.in/cx-complaint-dnd/v1/",
            GUARDIAN_NEW_API: "https://myairtelapp.bsbportal.com/app/guardian/api/bouncer/v1/"
        },
        CHATBOT: {
            default: "https://www.airtel.in/chatbot",
            CHATBOT_CONTEXT_URI: "/chatMediator/hns/v1"
        },
        CONSENT_SERVICE: {
            CONTEXT_URI: "https://digi-api.airtel.in/cs/"
        }
    },
    authPrefixPath: {
        HELPSUPPORT: "/s"
    },
    routerBasename: '/',
    parentUrl: '',
    staticAssetsBasePath: "https://assets.airtel.in",
    sentry: {
        enabled: true,
        environment: "production",
        dsn: "https://c31b243152aa500102338e63c8efef27@sentry.airtel.in/help-chatbot/1"
    }
};